import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableRow from "./TableRow"

class TableBody extends Component {
    _renderTableContent = () => {
        const {loading, products, onRefresh, arrSelected, onSelected, error} = this.props

        if (error) {
            return <tr>
                <td colSpan={12}>
                    <span className='text-danger'>{error}</span>
                </td>
            </tr>
        }

        if (loading && products.length <= 0) {
            return <tr>
                <td colSpan={12}>Loading ...</td>
            </tr>
        }

        return products.length > 0 && products.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                onRefresh={onRefresh}
                arrSelected={arrSelected}
                onSelected={onSelected}
            />
        })
    }

    render() {
        return (
            <tbody className="TableBody">
            {this._renderTableContent()}
            </tbody>
        )
    }
}

TableBody.propTypes = {
    products: PropTypes.array,
    loading: PropTypes.bool,
    error: PropTypes.string
}

export default TableBody
